import React from 'react'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import NurseSignupContext from './context';
import Header from 'components/Header'
import { useNavigate } from 'react-router';
import { nurseJobsURL } from 'routes/urls'
import DocumentUpload from 'components/DocumentUpload';
import GDCRegistration from 'components/GDCRegistration';
import HygienistReference from 'components/HygienistReference';
import ExperienceForm from 'components/ExperienceForm';
import Typography from '@mui/material/Typography';
import CheckboxMultiSelectField from 'components/CheckboxMultiSelectField';

const NurseSignupDocuments: React.FC = () => {
  const { toNextStep, toPreviousStep, nurse, emitGTMEvent, notification$, roles, setRoles } = React.useContext(NurseSignupContext)
  const navigate = useNavigate()
  
  function onSkip() {
    if (nurse) navigate(nurseJobsURL(nurse.nurse_id))
  }

  function onNext() {
    emitGTMEvent('nurse-signup-documents')
    toNextStep()
  }

  const canNext = React.useMemo(() => {
    if (!nurse) return false
    return !nurse.has_missing_documents
  }, [nurse])

  if (!nurse) return null

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
      <Header variant='h3' text='Documents'></Header>
      <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Typography variant='body1'>What roles are you interested in?</Typography>
        <CheckboxMultiSelectField
          sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}
          options={['dental nurse', 'hygienist'].map(role => ({ value: role, label: role }))}
          values={roles}
          onChange={(values) => setRoles(values as string[])}
        />
      </Box>
      <GDCRegistration nurseId={nurse.nurse_id} notification$={notification$} />
      <DocumentUpload nurseId={nurse.nurse_id} fileType='indemnity_insurance' />
      {/* For now we don't check for hepatitis_c, hiv, tb for scotland, so we exclude them. */}
      <DocumentUpload nurseId={nurse.nurse_id} fileType='immunizations' exclude={['hepatitis_c', 'hiv', 'tb']} />  
      <DocumentUpload nurseId={nurse.nurse_id} fileType='dbs' />
      <DocumentUpload nurseId={nurse.nurse_id} fileType='cpr' />
      <DocumentUpload nurseId={nurse.nurse_id} fileType='infection_control'/>
      {roles.includes('hygienist') ? (
        <React.Fragment>
          <DocumentUpload nurseId={nurse.nurse_id} fileType='resume' />
          <HygienistReference nurseId={nurse.nurse_id} />
        </React.Fragment>
      ) : null}
      {roles.includes('dental nurse') ? (
        <React.Fragment>
          <DocumentUpload nurseId={nurse.nurse_id} fileType='sedation_certificate' />
          <DocumentUpload nurseId={nurse.nurse_id} fileType='radiography_certificate' />
          <ExperienceForm nurseId={nurse.nurse_id} experienceType='implant' />
          <ExperienceForm nurseId={nurse.nurse_id} experienceType='orthodontics' />
        </React.Fragment>
      ) : null}
      {canNext ? (
        <Button variant="contained" color="primary" onClick={onNext}>Next</Button>
      ) : null}
      <Button variant="outlined" color="primary" onClick={toPreviousStep}>Back</Button>
      <Button variant="outlined" color="primary" onClick={onSkip}>Skip</Button>
    </Box>
  )
}

export default NurseSignupDocuments